import React from 'react';
import '../assets/css/notification-panels.css';
import RedWarningIcon from '../assets/img/red-warning-icon.svg';
import '../assets/css/notification-panels.css';

const NotificationPanels = ()=> {
	return (
	<div className="cstm-notifications-box">
	{/*	<div className="alert alert-danger alert-dismissable d-flex justify-content-between align-items-start notification-panel">
			<img src={RedWarningIcon} alt="" className="mr-2" />
			<div>
				<h6 className="fnt-smi-bld">Complete Address verification</h6>
				<p className="text-muted mr-2">Complete you digial address verification either on phone or desktop.</p>
	</div>	
			<button type="button" className="close" data-dismiss="alert">
				<span>&times;</span>
			</button>
		</div>	*/}
	</div>
	);
}

export default NotificationPanels;